import React from 'react';
import { i18n } from '@/utils';
import { Drawer } from '@/components';
import Icon from './icon';
import styles from './style.less';

interface ImageDrawerProps {
  /** 图片展示 */
  images: string[];
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: () => void;
}

const ImageDrawer: React.FC<ImageDrawerProps> = ({ images, onClose, onConfirm }) => {

  return (
    <div className={styles.imageDrawer}>
      <Drawer
        className={styles.imageDrawerContent}
        onClose={onClose}
        mask
      >
        <div className={styles.close} onClick={onClose}>
          <Icon type="close" color="#000" size={30} />
        </div>
        <div className={styles.imageWrapper}>
          {images.map(item => (
            <img key={item} src={item} />
          ))}
        </div>
        <div className={styles.confirm} onClick={onConfirm}>
          {i18n.format('modules.global.add.cart')}
        </div>
      </Drawer>
    </div>
  );
}

export default ImageDrawer;
